// react
import { useEffect } from 'react';

// context hooks
import useAsp from 'hooks/useAsp';

// types
import { useLocation } from 'react-router-dom';

const GoogleTag = () => {
  const { isThanks } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'googleTagManager';
    const scriptId2 = 'googleTagManager2';
    const scriptId3 = 'universalAnalytics';
    const scriptId4 = 'googleConversion';
    const scriptClassName = 'GoogleTagManager';
    const isExistScript = document.getElementById(scriptId);
    const isExistLoadScript = document.getElementsByClassName(scriptClassName);
    if (!!isExistScript) isExistScript.remove();
    if (isExistLoadScript.length) isExistLoadScript[0].remove();
    const script = document.createElement('script');
    const script1 = document.createElement('script');
    const script2 = document.createElement('script');
    const script3 = document.createElement('script');
    const script4 = document.createElement('script');
    script1.id = scriptId;
    script2.id = scriptId2;
    script3.id = scriptId3;
    script4.id = scriptId4;
    script.setAttribute('data-cfasync', 'false');
    script.setAttribute('data-pagespeed-no-defer', '');
    script1.type = 'text/javascript';
    script1.setAttribute('data-cfasync', 'false');
    script1.setAttribute('data-pagespeed-no-defer', '');
    script2.setAttribute('data-cfasync', 'false');
    script.innerHTML = isThanks
      ? `
    var dataLayer = window.dataLayer || [];
    dataLayer.push({'event': 'checkout_shopping_complete'});
      `
      : `
    var gtm4wp_datalayer_name = "dataLayer";
    var dataLayer = window.dataLayer || [];
      `;
    script1.innerHTML = isThanks
      ? `
    var dataLayer = window.dataLayer || [];
    dataLayer.push({'event': 'checkout_shopping_complete'});
      `
      : `
    var dataLayer_content = {"pagePostAuthor":"WiFi東京レンタルショップ"};
    dataLayer.push( dataLayer_content );
      `;
    script2.innerHTML = isThanks
      ? `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-WZ8H2VJ');
        `
      : `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-WZ8H2VJ')
        `;
    script3.innerHTML = isThanks
      ? ``
      : `
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
      ga('create', 'UA-40279313-3', 'auto');
      ga('send', 'pageview');
        `;
    script4.innerHTML = isThanks
      ? `
      /* <![CDATA[ */
      var google_conversion_id = 960802822;
      var google_conversion_language = "en";
      var google_conversion_format = "3";
      var google_conversion_color = "ffffff";
      var google_conversion_label = "B8jpCISgp2oQhuCSygM";
      var google_remarketing_only = false;
      /* ]]> */
        `
      : ``;
    document.head.appendChild(script);
    document.head.appendChild(script1);
    document.head.appendChild(script2);
    document.head.appendChild(script3);
    document.head.appendChild(script4);

    if (isThanks) {
      const googleAdScript = document.createElement('script');
      googleAdScript.type = 'text/javascript';
      googleAdScript.src = '//www.googleadservices.com/pagead/conversion.js';
      document.head.appendChild(googleAdScript);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-WZ8H2VJ"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="Google Tag Manager"
        ></iframe>
      </noscript>
      {isThanks && (
        <div
          dangerouslySetInnerHTML={{
            __html: `
            <noscript>
              <div style="display:inline;">
                <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/960802822/?label=B8jpCISgp2oQhuCSygM&guid=ON&script=0"/>
              </div>
            </noscript>
            `
          }}
        />
      )}
    </>
  );
};

export default GoogleTag;
